import React from 'react';
import './EmptyState.scss';
import { ReactComponent as EmptyStateIcon } from '../../images/no-data.svg';

interface EmptyStateProps {
  message?: string;
  secondaryMessage?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, secondaryMessage = ''  }) => {
  return (
    <section className='empty-state'>
      <div className='empty-state__icon'>
        <EmptyStateIcon />
      </div>
      <p className='empty-state__message'>
        {message || 'Data currently not available. Please check with your administrator'}
      </p>
      <p className='empty-state__message__secondary'>
        {secondaryMessage}
      </p>
    </section>
  );
};

export default EmptyState;
